var _style, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgWelcome3(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 219 219",
    style: {
      enableBackground: "new 0 0 219 219"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill-rule:evenodd;clip-rule:evenodd;fill:#42BE9B;}\n\t.st1{fill-rule:evenodd;clip-rule:evenodd;fill:#EDB649;stroke:#23506A;stroke-width:0.65;}\n\t.st2{fill-rule:evenodd;clip-rule:evenodd;fill:#23506A;stroke:#23506A;stroke-width:0.65;}\n\t.st3{fill-rule:evenodd;clip-rule:evenodd;fill:#EAF6F9;stroke:#23506A;stroke-width:0.65;}\n\t.st4{fill-rule:evenodd;clip-rule:evenodd;fill:#978EED;}\n\t.st5{fill-rule:evenodd;clip-rule:evenodd;fill:#FBFCFB;stroke:#23506A;stroke-width:0.65;}\n\t.st6{fill-rule:evenodd;clip-rule:evenodd;fill:#FFFFFF;stroke:#23506A;stroke-width:0.65;}\n\t.st7{fill:none;stroke:#23506A;stroke-width:0.65;}\n\t.st8{fill-rule:evenodd;clip-rule:evenodd;fill:#23506A;}\n\t.st9{fill:#23506A;}\n\t.st10{font-family:'National2-Medium';}\n\t.st11{font-size:6px;}\n\t.st12{fill-rule:evenodd;clip-rule:evenodd;fill:#335D75;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Third-ideation"
  }, /*#__PURE__*/React.createElement("g", {
    id: "final",
    transform: "translate(-852.000000, -401.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-9",
    transform: "translate(852.000000, 401.000000)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-Copy-11",
    className: "st0",
    width: 219,
    height: 219
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle-Copy-107",
    className: "st1",
    d: "M45.3,52.3h132.4c1.1,0,2,0.9,2,2v109.4c0,1.1-0.9,2-2,2H45.3c-1.1,0-2-0.9-2-2 V54.3C43.3,53.2,44.2,52.3,45.3,52.3z"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Rectangle-Copy-108",
    transform: "translate(84.000000, 52.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Mask"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle-Copy-109",
    className: "st2",
    d: "M91.3,52.3h86.3c2.2,0,4,1.8,4,4v105.4c0,2.2-1.8,4-4,4H91.3c-2.2,0-4-1.8-4-4V56.3 C87.3,54.1,89.1,52.3,91.3,52.3z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle-Copy-110",
    className: "st3",
    d: "M93.3,52.3h86.3c2.2,0,4,1.8,4,4v105.4c0,2.2-1.8,4-4,4H93.3c-2.2,0-4-1.8-4-4V56.3 C89.3,54.1,91.1,52.3,93.3,52.3z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle-Copy-111",
    className: "st4",
    d: "M94,50h90c1.1,0,2,0.9,2,2v11c0,1.1-0.9,2-2,2H94c-1.1,0-2-0.9-2-2V52 C92,50.9,92.9,50,94,50z"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-Copy-112",
    x: 96.3,
    y: 89.3,
    className: "st5",
    width: 80.3,
    height: 10.3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle-Copy-113",
    className: "st6",
    d: "M54.3,66.3h21.4c1.1,0,2,0.9,2,2v8.3c0,1.1-0.9,2-2,2H54.3c-1.1,0-2-0.9-2-2v-8.3 C52.3,67.2,53.2,66.3,54.3,66.3z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle-Copy-114",
    className: "st6",
    d: "M54.3,85.3h21.4c1.1,0,2,0.9,2,2v8.3c0,1.1-0.9,2-2,2H54.3c-1.1,0-2-0.9-2-2v-8.3 C52.3,86.2,53.2,85.3,54.3,85.3z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle-Copy-115",
    className: "st6",
    d: "M54.3,103.3h21.4c1.1,0,2,0.9,2,2v8.3c0,1.1-0.9,2-2,2H54.3c-1.1,0-2-0.9-2-2v-8.3 C52.3,104.2,53.2,103.3,54.3,103.3z"
  }), /*#__PURE__*/React.createElement("line", {
    id: "Path-5-Copy-52",
    className: "st7",
    x1: 72,
    y1: 110.5,
    x2: 65,
    y2: 110.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle-Copy-116",
    className: "st6",
    d: "M54.3,121.3h21.4c1.1,0,2,0.9,2,2v8.4c0,1.1-0.9,2-2,2H54.3c-1.1,0-2-0.9-2-2v-8.4 C52.3,122.2,53.2,121.3,54.3,121.3z"
  }), /*#__PURE__*/React.createElement("line", {
    id: "Path-5-Copy-53",
    className: "st7",
    x1: 72,
    y1: 127.5,
    x2: 65,
    y2: 127.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle-Copy-117",
    className: "st6",
    d: "M54.3,139.3h21.4c1.1,0,2,0.9,2,2v8.4c0,1.1-0.9,2-2,2H54.3c-1.1,0-2-0.9-2-2v-8.4 C52.3,140.2,53.2,139.3,54.3,139.3z"
  }), /*#__PURE__*/React.createElement("line", {
    id: "Path-5-Copy-54",
    className: "st7",
    x1: 71.7,
    y1: 145.5,
    x2: 65,
    y2: 145.5
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-Copy-118",
    x: 96.3,
    y: 114.3,
    className: "st5",
    width: 40.3,
    height: 10.3
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-Copy-119",
    x: 144.3,
    y: 114.3,
    className: "st5",
    width: 32.3,
    height: 10.3
  }), /*#__PURE__*/React.createElement("line", {
    id: "Path-5-Copy-55",
    className: "st7",
    x1: 127,
    y1: 83.5,
    x2: 96,
    y2: 83.5
  }), /*#__PURE__*/React.createElement("line", {
    id: "Path-5-Copy-56",
    className: "st7",
    x1: 169.6,
    y1: 75,
    x2: 96,
    y2: 74.5
  }), /*#__PURE__*/React.createElement("line", {
    id: "Path-5-Copy-57",
    className: "st7",
    x1: 149.5,
    y1: 132.5,
    x2: 96,
    y2: 132.5
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group-3",
    transform: "translate(96.000000, 139.000000)"
  }, /*#__PURE__*/React.createElement("line", {
    id: "Path-5-Copy-58",
    className: "st7",
    x1: 39,
    y1: 1.5,
    x2: 8,
    y2: 1.5
  }), /*#__PURE__*/React.createElement("line", {
    id: "Path-5-Copy-59",
    className: "st7",
    x1: 39,
    y1: 6.5,
    x2: 8,
    y2: 6.5
  }), /*#__PURE__*/React.createElement("line", {
    id: "Path-5-Copy-60",
    className: "st7",
    x1: 39,
    y1: 11.5,
    x2: 8,
    y2: 11.5
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval-Copy-36",
    className: "st8",
    cx: 1.5,
    cy: 1.5,
    r: 1.5
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval-Copy-38",
    className: "st8",
    cx: 1.5,
    cy: 6.5,
    r: 1.5
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval-Copy-39",
    className: "st8",
    cx: 1.5,
    cy: 11.5,
    r: 1.5
  })), /*#__PURE__*/React.createElement("circle", {
    id: "Oval-Copy-37",
    className: "st2",
    cx: 59,
    cy: 110,
    r: 1.7
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-Copy-120",
    x: 57.3,
    y: 125.3,
    className: "st2",
    width: 3.3,
    height: 3.4
  }), /*#__PURE__*/React.createElement("line", {
    id: "Path-5-Copy-61",
    className: "st7",
    x1: 127,
    y1: 108,
    x2: 96,
    y2: 108
  }), /*#__PURE__*/React.createElement("line", {
    id: "Path-5-Copy-62",
    className: "st7",
    x1: 175,
    y1: 108,
    x2: 144,
    y2: 108
  }), /*#__PURE__*/React.createElement("text", {
    transform: "matrix(1 0 0 1 59 75)",
    className: "st9 st10 st11"
  }, "ABC"), /*#__PURE__*/React.createElement("text", {
    transform: "matrix(1 0 0 1 60 94)",
    className: "st9 st10 st11"
  }, "123"), /*#__PURE__*/React.createElement("g", {
    id: "Icon-_x2F_-Dark-_x2F_-CaretDown-Copy-2",
    transform: "translate(56.000000, 144.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Color",
    className: "st12",
    d: "M0.7,0.7C0.4,0.7,0.4,0.8,0.5,1l2.2,2.2c0.2,0.2,0.4,0.2,0.6,0L5.5,1c0.2-0.2,0.1-0.3-0.1-0.3 H0.7z"
  })))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgWelcome3);
export default __webpack_public_path__ + "static/media/Welcome3.0bb1fc3990edd0bd1ddee4433e4cc032.svg";
export { ForwardRef as ReactComponent };